<template style="background: #FAFAFA;">
    <div>
        <div class="container-fluid mt-5">
            <div class="input-group col-md-8 mr-auto ml-auto search-container position-relative">
                <input type="text" class="form-control input-search" id="search" placeholder="Search kid name" v-model="search">
                <div class="input-group-append">
                    <button :disabled="searchloader || search == ''" @click="searchPostingByKidName()" class="input-group-text" id="basic-addon2">
                        {{ searchloader ? 'Loading' : 'Search' }}
                        <i
                        class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                        v-if="searchloader"
                        ></i>
                    </button>
                </div>
            </div>
            <div class="category_list">
                <h6 @click="fetchChallengesList()" :class="activeIndex == 0 ? 'activeCate' : '' ">All</h6>
                <h6 @click="selectCategory(item); fetchPostingListByChallengeId(item.category_id)" :class="activeIndex == item.challenge_category.id ? 'activeCate' : '' " v-if="challenges" v-for="(item, index) in challenges" :key="index">{{ item.challenge_category.name }}</h6>
            </div>

            <div v-if="loading2">
                <PageLoader></PageLoader>
            </div>

            <div v-if="postings.length == 0 && !loading2">
                <EmptyState :emptyData="emptyDataObject"></EmptyState>
            </div>

            <div v-else class="display-body">
                <div class="row">
                    <div class="col-md-4 mb-4" v-for="(item, index) in postings"
                        :key="index">
                        <div class="chalenge-item">
                                <div class="kid-name-profile">
                                    <img v-if="item.kid.avatar_url != null" :src="item.kid.avatar_url" alt="pix" style="width: 34px; height: 34px;">
                                    <img v-else src="../../assets/icons/profile-icon.svg" alt="pix">
                                    <div>
                                        <!-- <h5>{{item.kid.firstname}} {{item.kid.lastname}}</h5> -->
                                        <h5>{{item.kid.display_name}}</h5>
                                        <p>#{{ item.challenge.title }}</p>
                                    </div>
                                </div>

                                <div class="challenge-body">
                                    <!-- <h3>Wole Soyinka</h3> -->
                                    <h4> 
                                        {{ item.write_up }}
                                    </h4>
                                    <!-- <h6>#{{ item.challenge.title.replace(/\s+/g, '') }}</h6> -->
                                    <h6>#{{ item.challenge.title}}</h6>

                                    <div class="image-holder">
                                        <img v-if="getPriorityMedia(item.media).url && getPriorityMedia(item.media).media_type === 'image'"  class="w-100" :src="getPriorityMedia(item.media).url" alt="media">
                                        <!-- Display Image if type is image -->
                                        <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                        <!-- Display Video if type is video -->
                                        
                                        <video v-else-if="getPriorityMedia(item.media).media_type === 'video'" 
                                            :src="getPriorityMedia(item.media).url" controls>
                                        Your browser does not support the video tag.
                                        </video>
                                        
                                        <div class="count-numbers">
                                            <img src="../../assets/superkids/diamond.png" alt="">
                                            <p>{{ item.points || 0}}</p>
                                           
                                        </div>
                                    </div>
                                
                                    <div class="form-group vote-btn">
                                        <button class="btn vote-now" @click="voteNow(item); loadingItemId = item.id" :disabled="(loader && loadingItemId == item.id) || isButtonDisabled(item.challenge.voting_start_date_and_time, item.challenge.voting_end_date_and_time)">
                                            <!-- {{ loader && loadingItemId == item.id ? 'Voting': 'Vote now'}} -->
                                            {{ getButtonText(item, item.challenge.voting_start_date_and_time, item.challenge.voting_end_date_and_time) }}
                                            <i
                                            class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                            v-if="loader && loadingItemId == item.id"
                                            ></i>
                                        </button>
                                        <!-- <button class="btn vote-now" @click="voteNow(item)" :disabled="loader" v-if="item.voted == 'NO'">
                                            {{ loader ? 'Voting': 'Vote now'}}
                                            <i
                                            class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                            v-if="loader"
                                            ></i>
                                        </button> -->
                                        <!-- <button class="btn vote-now" disabled v-if="item.voted == 'YES'">Voted</button> -->
                                        <button class="btn view-more-btn" v-if="(item.media).length > 1 " data-toggle="modal" data-target="#mediaView" @click="modalMedia = item.media;">View More</button>
                                    </div>
                                </div>
                        </div>
                    </div>

                </div>
                <div class="modal fade" id="mediaView" tabindex="-1" aria-labelledby="mediaView" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title title-modal" id="media-view">More Media</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body more-media">
                            <div v-for="(more, index) in modalMedia" :key="index" class="">
                                
                                <img v-if="more.url && more.media_type === 'image'"  class="w-100 mb-3" :src="more.url" alt="media">
                                <!-- Display Image if type is image -->
                                <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                <!-- Display Video if type is video -->
                                <video class="mb-3" v-if="more.media_type === 'video'" 
                                    :src="more.url" controls style="width: 100%;">
                                    Your browser does not support the video tag.
                                </video>                                
                            </div>
                        </div>
                    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                        </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import EmptyState from "../../components/EmptyState.vue";
import moment from "moment";
export default {
    name: "SubmissionComponent",
    components: {
        // Header
        PageLoader,
        EmptyState,
    },
    data() {
        return {
            loading: false,
            loading2: false,
            loader: false,
            searchloader: false,
            loadingItemId: null,
            search: "",
            challenges: [],
            activeIndex: 0,
            postings: [],
            emptyDataObject: {
                header: "No Submission yet",
                option: "Yet to recieve any submission"
            },
            modalMedia: ''
        }
    },
    computed: {
        // This logic runs automatically whenever mediaFiles changes
        firstImage() {
            return this.postings.media.find(file => file.type === 'image');
        }
    },
    mounted() {
        this.fetchChallenges();
        this.fetchChallengesPostingList();
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        goBack() {
            this.$router.back();
        },
        voteNow(data) {
            this.loader = true;
            try {
                Api.postRequest(`vote`, {
                    platform: 'web',
                    posting_id: data.id,
                }).then (res => {
                    // console.log("Voted response", res);
                    this.loader = false;
                    if (res.data.success) {
                        this.fetchChallenges();
                        this.fetchChallengesPostingList();
                        return this.$store.commit("setApiSuccess", "Voted successfull");
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("err:", err);
                    this.loader = false;
                })
            } finally {
                // console.log("closed")
            }
        },
        getPriorityMedia(files) {
            // console.log("Files img", files)
            if (!files || !Array.isArray(files)) return null;
            // return files.find(file => file.media_type === 'image'); //uncomment later and comment out the next lines

            // const lastImage = [...files].reverse().find(file => file.media_type === 'image');
            // return lastImage ? lastImage.url : null;

            // const firstImage = files.find(f => f.media_type === 'image');
            // if (firstImage) return firstImage;  

            const lastImage = [...files].reverse().find(f => f.media_type === 'image');
            if (lastImage) return lastImage;

            // 2. If no image, find the first video
            const firstVideo = files.find(f => f.media_type === 'video');
            if (firstVideo) return firstVideo;

            return null;
            
        },
        selectCategory(item) {
            this.activeIndex =  item.challenge_category.id;
        },
        fetchChallengesList() {
            this.activeIndex = 0;
            this.fetchChallengesPostingList();
        },
        async searchPostingByKidName() {
            if (this.search == '') {
                return this.$store.commit("setApiFailed", 'Enter kid name');
            }
            this.searchloader = true;
            try {
                    Api.postRequest(`search-postings-for-current-cohort`, {name: this.search}).then(res => {
                        // console.log("SEARCH DONE,", res);
                        this.searchloader = false;
                        if (res.data.success) {
                            this.postings = res.data.data;
                            this.activeIndex == null;
                            // const testing = {
                            //     created_at: "2026-03-24T02:43:13.000000Z",
                            //     url: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg",
                            //     id: 4,
                            //     media_type: "image",
                            //     super_kid_challenge_postings_id: "1",
                            //     updated_at: "2026-03-24T02:43:13.000000Z"
                            // }
                            // // this.postings.map(media => [...media, testing]);
                            // this.postings = this.postings.map(user => ({
                            //     ...user,
                            //     media: [...(user.media || []), testing]
                            // }));
                        }
                        if (res.data.error) {
                            return this.$store.commit("setApiFailed", res.data.error);
                        }
                    }).catch(err => {
                        console.log("err:", err);
                        this.searchloader = false;
                        
                    })
            } finally {
                // console.log("closed");
            }
        },
        async fetchChallengesPostingList() {
            this.loading2 = true;
            // fetch-postings-randomly
            try {
                await Api.getRequest(`fetch-postings-for-current-cohort`).then(res => {
                // console.log("Posting list", res);
                
                if(res.data.success) {
                    this.postings = res.data.data;
                    this.loading2 = false;
                    this.search = '';
                    const testing = {
                        created_at: "2026-03-24T02:43:13.000000Z",
                        url: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg",
                        id: 4,
                        media_type: "image",
                        super_kid_challenge_postings_id: "1",
                        updated_at: "2026-03-24T02:43:13.000000Z"
                    }
                    // this.postings.map(media => [...media, testing]);
                    // used when testing files
                    // this.postings = this.postings.map(user => ({
                    //     ...user,
                    //     media: [...(user.media || []), testing]
                    // }));
                    // console.log("postings 2", this.postings); 
                   
                }
                if (res.data.error) {
                    this.loading2 = false;
                    return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
                console.log("err:", err);
                this.loading2 = false;
            })
            } finally {
                // console.log("closed")
            }
        },
        async fetchPostingListByChallengeId(id) {
            this.loading = true;
            // fetch-postings-randomly
           try {
            await Api.getRequest(`fetch-postings-for-current-cohort-by-challenge-id/${id}`).then(res => {
                // console.log("Posting list by category", res);
                this.loading = false;
                if(res.data.success) {
                    this.postings = res.data.data;
                    this.search = "";
                    // const testing = {
                    //     created_at: "2026-03-24T02:43:13.000000Z",
                    //     url: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg",
                    //     id: 4,
                    //     media_type: "image",
                    //     super_kid_challenge_postings_id: "1",
                    //     updated_at: "2026-03-24T02:43:13.000000Z"
                    // }
                    // this.postings.map(media => [...media, testing]);
                    // this.postings = this.postings.map(user => ({
                    //     ...user,
                    //     media: [...(user.media || []), testing]
                    // }));
                    // console.log("postings 2", this.postings); 
                   
                }
                if (res.data.error) {
                    this.loading = false;
                    return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
                console.log("err:", err);
                this.loading = false;
            })
           } finally {
            // console.log("closed")
           }
        },
        fetchChallenges() {
            this.loading = true;
            Api.getRequest(`fetch-super-kids-challenges`).then(res => {
                this.loading = false;
                // console.log("Challenges", res);
                this.challenges = res.data.data;
            }).catch(err => {
                console.log("err:", err);
                this.loading = false;
            })
        },
        isButtonDisabled(start, end) {
            const now = new Date();
            const startDate = new Date(start);
            const endDate = new Date(end);

            // Returns true (disabling the button) if NOW is before start OR after end
            return now < startDate || now > endDate;
        },
        getButtonText(item, start, end) {
            const now = new Date();
            if (now < new Date(start)) return 'Voting Opens soon';
            if (now > new Date(end)) return 'Challenge Ended';
            if (this.loader && this.loadingItemId == item.id ) return 'Voting'
            return 'Vote Now';
        },
    },
}
</script>


<style lang="scss" scoped>
.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
}
.name-tag {
    margin-top: 30px;
    margin-bottom: 30px;
    h3 {
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;  
        color: #4B4B4F;
        text-align: left;
    }

}
.count-item {
    border: 1px solid #F5F7FA;
    background: #ffffff;
    border-radius: 20px;
    padding: 12px 16px;
    h5 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #5D6F7C;
        text-align: left;
        margin-bottom: 15px;
    }
    h2 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 28px;
        color: #1C2B3A;
        line-height: 100%;
        text-align: left;
    }
}

.latest-achievement {
    margin-top: 80px;
    h6 {
        // margin-top: 30px;
        font-family: Lato;
        font-weight: 500;
        font-size: 20px;
        line-height: 26px;
        color: #5D6F7C;
        text-align: left;
    }
}

.achievement_list {
    margin-top: 20px;
    background: #ffffff;
    h5 {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: #000000;
        text-align: left;
        margin-bottom: 0;
    }
    h4 { 
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        color: #1C2B3A;
        text-align: left;
    }
}

.achievement_item {
    padding: 20px 15px;
    border-bottom: 1px solid #e8e5e5;
}

.carosel-section {
    margin-bottom: 50px !important;
}

.middle-section {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 30px;
    button {
        background-color: #2EBFCA; 
        color: #ffffff;
        font-family: Lato;
        font-weight: 600;
        font-size: 14px;
        box-shadow: none;
        outline: 0;
        border: 1px solid #ffffff;
        border-radius: 50px;
        white-space: nowrap;
    }
}


//carousel begins
.carousel-indicators li {
  width: 20px;
  height: 20px;
  border-radius: 50px;        /* makes it round */
  background-color: #E6E6E6; /* inactive color */
  opacity: 1;                /* remove Bootstrap fade */
  margin: 0 5px;
}

.carousel-caption {
//   background: rgba(0, 0, 0, 0.5);
  padding: 20px;
  padding-top: 0 !important;
  border-radius: 5px;
  position: static;
  width: 100%;
}
.carousel-indicators .active {
  width: 30px;               /* pill width */
  height: 20px;
  border-radius: 20px;       /* pill shape */
  background-color: #2EBFCA;     /* active color */
}
// * {
//   outline: 1px solid red;
// }
.overlay-content {
  position: absolute;
//   top: 50%;
  top: 45%;
  left: 8%;
//   margin: 0 auto;
//   margin-left: 8%;
  transform: translateY(-50%);
  color: #fff;
  max-width: 450px;
  width: 100%;
  text-align: left;
//   box-sizing: border-box;
  h6 {
    font-family: Nunito;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align: left;
  }
  h3 {
    // margin-top: 20px;
    font-family: Nunito;
    font-weight: 800;
    font-size: 35px;
    line-height: 50px;
    color: #000000;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  p {
    margin-top: 15px;
    font-family: Lato;
    font-weight: 400;
    font-size: 20px;
    color: #5D6F7C;
    line-height: 28px;
    text-align: left;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;   /* number of lines allowed */
    -webkit-box-orient: vertical;
  }
  h4 {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 100%;
    text-align: left;

  }
  button {
    background: #2EBFCA;
    color: #ffffff;
    font-family: Lato;
    font-weight: 600;
    font-size: 12px;
    box-shadow: none;
    outline: 0;
    border: 1px solid #ffffff;
    border-radius: 50px;
    height: 36px;
    width: 136px;
    margin-top: 30px;
  }
}

.small-text {
  font-size: 14px;
  margin-bottom: 10px;
}

.main-title {
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 15px;
}

.description {
  font-size: 16px;
}

.carousel-item {
    img {
        border-radius: 20px;
        height: 400px;
        object-fit: cover;
    }
}

.carousel-control-next, .carousel-control-prev {
    width: 8%;
}
.carousel-indicators {
  bottom: 20px;
  position: static; 
}



@media (max-width: 768px) {
  .carousel-item img {
    height: auto;
    min-height: 400px;
    object-fit: cover;
  }
  .carousel-indicators {
    position: static;   /* removes absolute positioning */
    margin-top: 15px;   /* space below image */
  }
  .overlay-content {
    max-width: 100%;
    width: 100%;
    top: 50%;
    padding: 0 15px;
    h3 {
        margin-top: 7px;
        font-size: 26px;
        line-height: 38px;
    }
    p {
        margin-top: 0;
    }
  }
}
//carousel ends

@media only screen and (max-width: 599px) {
    .count-item {
        padding: 12px 15px;
        h5 {
            font-size: 12px;
        }
        h2 {
            font-size: 18px;
        }
    }
    .overlay-content {
        max-width: 100%;
        width: 100%;
        padding: 0 15px;
        margin-left: 0;
        left: 0;
    }
}

</style>

<style lang="scss" scoped>
.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
    button {
        background: #2EBFCA;
        color: #F5F7FA;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        border-radius: 50px;
    }
}

.input-search {
    // margin-top: 40px;
    // margin-bottom: 40px;
    // border: 1px solid #F5F7FA;
    border: 1px solid #e3e3e3;
    border-radius: 50px;
    background: #ffffff;
    color: #5D6F7C;
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    outline: 0;
    box-shadow: none;
}


.category_list {
    margin-top: 30px;
    display: flex;
    overflow-x: scroll;
    gap: 25px;
    h6 {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        color: #5D6F7C;
        background: #F0F0F0;
        border: 1px solid #F5F7FA;
        border-radius: 50px;
        padding: 4px 16px;
        white-space: nowrap;
        cursor: pointer;
    }
    .activeCate {
        border: 1px solid #F5F7FA;
        background: #CAECF9;
        color: #2EBFCA;
    }
}

.display-body {
    margin-top: 45px;
}

.chalenge-item {
    background: #ffffff;
    border-radius: 20px;
    // border: 1px solid #F5F7FA;
    border: 1px solid #e3e3e3;
    padding: 12px;
    margin-bottom: 15px;
    // max-height: 339px;
    height: 100%;
}

.kid-name-profile {
    display: flex;
    gap: 10px;
    text-align: left;
    align-items: center;
    margin-bottom: 30px;
    img {
        border-radius: 50px;
    }
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
        color: #1C2B3A;
        margin-bottom: 8px;
    }
    p {
        margin-bottom: 0;
        color: #5D6F7C;
        font-family: Lato;
        font-weight: 800;
        font-size: 13px;
        line-height: 19px;

    }
}


.image-holder {
    height: 339px;
    position: relative;
}

.count-numbers {
    position: absolute;
    top: 0;
    right: 25px;
    display: flex;
    align-items: center;

    p {
        font-family: Lato;
        // background: rgba(0, 0, 0, 0.6);
        background-color: #7d7b7b99;
        padding: 4px;
        border-radius: 50px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
        color: #fff;
        font-size: 13px;
        // width: 30px;
        // height: 30px;
        width: 28px;
        height: 28px;
        text-align: center;
        margin-bottom: 0;
    }

}

.challenge-body {
    height: 100%;
   img {
    border-radius: 8px;
    // max-height: 339px;
    height: 100%;
    object-fit: contain;
   }
   video {
        border-radius: 8px;
        // width: 600px;
        // max-height: 339px;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
    h3 {
        text-align: left;
        font-family: Nunito Sans;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        // color: #1C2B3A;
    }
    h4, h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        text-align: left;
    }
    h4 {
        color:  #5D6F7C;
    }
    h3 {
        color: #1C2B3A;
    }
    h6 {
        margin-top: 20px;
        color: #2EBFCA;
        display: none;
    }
}

.vote-btn {
    margin-top: 25px;
    display: flex;
    gap: 10px;
    .vote-now {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
    .view-more-btn {
        border: 1px solid #2AB3E6;
        border-radius: 50px;
        color: #2AB3E6;
        white-space: nowrap;
        outline: 0;
        box-shadow: none;
    }
}
.input-group-text {
    border-top-right-radius: 50px !important;
    border-bottom-right-radius: 50px !important;
}
.search-container {
  position: relative; 
  width: 100%;
}

.more-media {
    img {
        max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
    video {
        // max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
}
</style>